// extracted by mini-css-extract-plugin
export default {"icon":"Download_icon__APT0y"};